import { render, staticRenderFns } from "./TDSList.vue?vue&type=template&id=64e1f1fa&"
import script from "./TDSList.vue?vue&type=script&lang=js&"
export * from "./TDSList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports